var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63672 6.18506C2.63672 5.38941 2.95279 4.62635 3.5154 4.06374C4.07801 3.50113 4.84107 3.18506 5.63672 3.18506H19.1367C19.9324 3.18506 20.6954 3.50113 21.258 4.06374C21.8206 4.62635 22.1367 5.38941 22.1367 6.18506V18.1851C22.1367 18.9807 21.8206 19.7438 21.258 20.3064C20.6954 20.869 19.9324 21.1851 19.1367 21.1851H5.63672C4.84107 21.1851 4.07801 20.869 3.5154 20.3064C2.95279 19.7438 2.63672 18.9807 2.63672 18.1851V6.18506ZM6.60672 7.15506C6.74734 7.01461 6.93797 6.93572 7.13672 6.93572C7.33547 6.93572 7.52609 7.01461 7.66672 7.15506L9.91672 9.40506C10.0572 9.54568 10.1361 9.73631 10.1361 9.93506C10.1361 10.1338 10.0572 10.3244 9.91672 10.4651L7.66672 12.7151C7.52454 12.8475 7.3365 12.9197 7.1422 12.9162C6.9479 12.9128 6.76251 12.8341 6.6251 12.6967C6.48768 12.5593 6.40897 12.3739 6.40554 12.1796C6.40212 11.9853 6.47424 11.7972 6.60672 11.6551L8.32672 9.93506L6.60672 8.21506C6.46627 8.07443 6.38738 7.88381 6.38738 7.68506C6.38738 7.48631 6.46627 7.29568 6.60672 7.15506ZM10.8867 11.4351C10.6878 11.4351 10.497 11.5141 10.3564 11.6547C10.2157 11.7954 10.1367 11.9861 10.1367 12.1851C10.1367 12.384 10.2157 12.5747 10.3564 12.7154C10.497 12.856 10.6878 12.9351 10.8867 12.9351H13.8867C14.0856 12.9351 14.2764 12.856 14.417 12.7154C14.5577 12.5747 14.6367 12.384 14.6367 12.1851C14.6367 11.9861 14.5577 11.7954 14.417 11.6547C14.2764 11.5141 14.0856 11.4351 13.8867 11.4351H10.8867Z",
    fill: "#0A122A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.cba5b7ba2cd719dfc25ed9ae5ec7b089.svg";
export { ForwardRef as ReactComponent };